import PropTypes from 'prop-types'
import { Button, Upload } from 'antd'

const FileInput = ({
  fileFieldName,
  fileFieldId,
  labelTitle,
  onChange,
  isDisabled,
  multiple = false,
  accept,
  className = '',
}) => {
  return (
    <Upload
      name={fileFieldName}
      multiple={multiple}
      disabled={isDisabled}
      showUploadList={false}
      accept={accept}
      beforeUpload={(file) => {
        onChange(file)
        return false
      }}
    >
      <Button
        id={fileFieldId}
        data-testid="importer-upload"
        type="link"
        disabled={isDisabled}
        className={ className }
      >
        {labelTitle}
      </Button>
    </Upload>
  )
}

FileInput.propTypes = {
  fileFieldName: PropTypes.string.isRequired,
  fileFieldId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelTitle: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  multiple: PropTypes.bool,
  className: PropTypes.string,
}

export default FileInput
